import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  margin: 20px;
  right: 0;
  z-index: 999;
`;

export const HeaderUserInfo = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    transform: ${prop => prop.open ? 'rotate(180deg) !important' : 'none'};
    transition: ease-in-out .2s;
  }
`;

export const HeaderUserName = styled.small`
  font-size: 12px;
  color: ${colors.textPrimary};
  margin-right: 10px;
`;

export const HeaderAdviserCode = styled.small`
  font-size: 12px;
  color: ${colors.textPrimary};
  margin-right: 10px;
`;

export const HeaderUserOptions = styled.div`
  opacity: ${prop => prop.open ? '1' : '0'};
  height: ${prop => prop.open ? 'auto' : '0'};
  overflow: ${prop => prop.open ? '' : 'hidden'};
  z-index: 1;
  width: 180px;
  right: 40px;
  position: absolute;
  top: 28px;
  background: ${colors.white};
  padding: 15px 0;
  border-radius: 5px;
  box-shadow: 0px 5px 5px 0px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 5px 0px ${colors.shadow};
  -moz-box-shadow: 0px 5px 5px 0px ${colors.shadow};
  transition: opacity .1s ease-out;
  cursor: default;

  &::before {
    content: '';
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 10px 10px 0px 10px;
    border-color: ${colors.white} transparent transparent transparent;
    display: inline-block;
    vertical-align: middle;
    position: absolute;
    top: -10px;
    transform: rotate(180deg);
    right: 10px;
    margin: 0 auto;
  }
`;

export const HeaderUserOptionLine = styled.div`
  height: 32px;
  width: 100%;
  color: ${colors.textPrimary};
  display: flex;
  align-items: center;
  padding: 0 20px;
  font-size: 14px;
  line-height: 23px;
  cursor: pointer;
  transition: .2s;

  &:hover {
    background: ${colors.menuHover};
  }

  &:first-child {
    svg {
      margin-left: -2px;
    }
  }

  svg {
    margin-right: 10px;
  }
`;
